import z from 'zod';

export type OtherString = string & {};
export const OtherString = z.string() as z.ZodType<OtherString>;
